import type { FirebaseConfig, FirebaseEnvironment } from '../../types/firebase';
import { env } from '../core/env';

export const getFirebaseConfig = (): FirebaseConfig => {
  return {
    apiKey: env.firebaseApiKey,
    authDomain: env.firebaseAuthDomain,
    databaseURL: env.firebaseDatabaseUrl,
    projectId: env.firebaseProjectId,
    storageBucket: env.firebaseStorageBucket,
    messagingSenderId: env.firebaseMessagingSenderId,
    appId: env.firebaseAppId,
    measurementId: env.firebaseMeasurementId,
  };
};

export const getFirebaseEnvironment = (): FirebaseEnvironment => {
  return env.appEnv as FirebaseEnvironment;
};

export const validateFirebaseConfig = (config: FirebaseConfig): boolean => {
  const requiredFields = [
    'apiKey',
    'authDomain',
    'projectId',
    'storageBucket',
    'messagingSenderId',
    'appId',
  ];

  for (const field of requiredFields) {
    if (!config[field as keyof FirebaseConfig]) {
      console.error(`Firebase configuration missing required field: ${field}`);
      return false;
    }
  }

  return true;
};
